import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("image3", component(opts));
  editor.BlockManager.add("image3", block(opts));
};